const registerRestoreAjaxinate = () => {
  // 1. CONFIGURATION
  const selectors = {
    container: '#AjaxinateLoop',        // The div containing your products
    pagination: '#AjaxinatePagination', // The div containing the "Load More" button
    nextLink: '#AjaxinatePagination a', // The actual "Load More" anchor tag
    productLinks: '#AjaxinateLoop a[href*="/products/"]' // Links to products
  };

  const storageKey = 'shopify_collection_scroll_restore';
  
  // Track how many pages we have currently loaded. Starts at 1.

  // ---------------------------------------------------------
  // PART A: Track "Load More" Clicks
  // ---------------------------------------------------------
  // We listen to the pagination container. If the "next" link is clicked, we increment our counter.
  const paginationContainer = document.querySelector(selectors.pagination);
  if (paginationContainer) {
    paginationContainer.addEventListener('click', function(e) {
      if (e.target.closest(selectors.nextLink)) {
        pagesLoaded++;
        // Optional: Save this immediately in case the browser crashes/closes
        // But for back-button logic, saving on product click (Part B) is usually enough.
      }
    });
  }

  // ---------------------------------------------------------
  // PART B: Save State on Product Click
  // ---------------------------------------------------------
  const container = document.querySelector(selectors.container);
  if (container) {
    container.addEventListener('click', function(e) {
      const link = e.target.closest('a[href*="/products/"]');
      if (link) {
        const state = {
          scrollPos: window.scrollY,
          pagesToRestore: pagesLoaded, // Save our tracker variable
          collectionPath: window.location.pathname,
          timestamp: Date.now()
        };
        sessionStorage.setItem(storageKey, JSON.stringify(state));
      }
    });
  }

  // ---------------------------------------------------------
  // PART C: Restore State (Only on Back Button)
  // ---------------------------------------------------------
  const savedState = sessionStorage.getItem(storageKey);

  // Check if navigation was "Back/Forward"
  let isBackButton = false;
  if (window.performance && window.performance.getEntriesByType) {
    const nav = window.performance.getEntriesByType("navigation");
    if (nav.length > 0 && nav[0].type === 'back_forward') isBackButton = true;
  } else if (window.performance && window.performance.navigation) {
    if (window.performance.navigation.type === 2) isBackButton = true;
  }
  const queryString = window.location.search;
  const urlParams = new URLSearchParams(queryString);
  const breadcrumbClick = urlParams.get('breadcrumb_return');
  if (breadcrumbClick) {
    const newUrl = new URL(window.location);
    newUrl.searchParams.delete('breadcrumb_return');
    window.history.replaceState({}, '', newUrl);
  }


  if (savedState && isBackButton || savedState && breadcrumbClick) {
    const state = JSON.parse(savedState);
    const isSamePage = state.collectionPath === window.location.pathname;
    const isRecent = (Date.now() - state.timestamp) < 1000 * 60 * 30; // 30 mins

    if (isSamePage && isRecent && state.pagesToRestore > 1) {
      
      if ('scrollRestoration' in history) history.scrollRestoration = 'manual';

      // Update our global tracker so it matches what we are about to restore
      pagesLoaded = state.pagesToRestore;

      const fetchPage = async (pageNum) => {
        // Stop if we have loaded all the required pages
        if (pageNum > state.pagesToRestore) {
          window.scrollTo(0, state.scrollPos);
          sessionStorage.removeItem(storageKey);
          return;
        }

        try {
          const response = await fetch(`${window.location.pathname}?page=${pageNum}`);
          const text = await response.text();
          const parser = new DOMParser();
          const doc = parser.parseFromString(text, 'text/html');

          // 1. Append Products
          const newProducts = doc.querySelector(selectors.container).innerHTML;
          document.querySelector(selectors.container).insertAdjacentHTML('beforeend', newProducts);

          // 2. Handle the "Next" Button
          const newNextLink = doc.querySelector(selectors.nextLink);
          const currentNextLink = document.querySelector(selectors.nextLink);
          
          if (currentNextLink) {
            if (newNextLink) {
              // Update href for next loop
              currentNextLink.href = newNextLink.href; 
            } else {
              // We reached the end (no next link in new content), remove button
              currentNextLink.remove();
            }
          }

          // Fetch next page
          fetchPage(pageNum + 1);

        } catch (err) {
          console.error('Scroll Restore Error:', err);
        }
      };

      // Start fetching from Page 2
      fetchPage(2);
    } else {
    //   sessionStorage.removeItem(storageKey);
    }
  } else {
    // sessionStorage.removeItem(storageKey);
  }
};

document.addEventListener("DOMContentLoaded", function () {
  registerRestoreAjaxinate()
});